<div class="content">
  <form class="treatment-form" [formGroup]="treatmentHistoryForm" (submit)="addTreatment()">
    <mat-form-field>
      <mat-label>{{ 'description' | translate }}</mat-label>
      <input matInput type="text" name="description" formControlName="description" />
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'start_date' | translate }}</mat-label>
      <input
        matInput
        type="text"
        autocomplete="off"
        [matDatepicker]="startpicker"
        formControlName="begin_date"
        (focus)="startpicker.open()"
      />
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(treatmentHistoryForm.controls.begin_date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'end_date' | translate }}</mat-label>
      <input matInput type="text" autocomplete="off" [matDatepicker]="endpicker" formControlName="end_date" (focus)="endpicker.open()" />
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(treatmentHistoryForm.controls.end_date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
    </mat-form-field>
    <gc-location-input
      (placeAutoComplete)="populateAddress($event)"
      formControlName="place"
      [forLocation]="'anyLocation'"
    ></gc-location-input>
    <button mat-flat-button type="submit" class="add-button" [disabled]="treatmentHistoryForm.invalid">
      <mat-icon svgIcon="plus"></mat-icon>
      {{ 'add_treatment' | translate }}
    </button>
    <div class="divider"></div>
  </form>
  <div *ngIf="historyListForm">
    <form [formGroup]="historyListForm">
      <div class="treatments-display">
        <mat-accordion multi="true" formArrayName="rowList">
          <mat-expansion-panel
            class="treatment-line"
            *ngFor="let treatment of rowListControl.controls; let i = index"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [formGroupName]="i"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{
                  'date_range_label'
                    | translate
                      : {
                          fromDate: (treatment.get('begin_date').value | customDate: 'dd LLLL yyyy'),
                          toDate: (treatment.get('end_date')?.value | customDate: 'dd LLLL yyyy'),
                        }
                }}
              </mat-panel-title>
              <mat-panel-description *ngIf="(isMobile$ | async) === false">
                {{ 'description_colon_value' | translate: { value: treatment.get('description').value } }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <mat-form-field>
                <mat-label>{{ 'description' | translate }}</mat-label>
                <input matInput type="text" name="description" formControlName="description" />
              </mat-form-field>
              <mat-form-field class="date-field">
                <mat-label>{{ 'start_date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="startpicker"
                  formControlName="begin_date"
                  (focus)="startpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                <mat-datepicker #startpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(treatment.controls.begin_date)">This date is invalid</mat-error>
              </mat-form-field>
              <mat-form-field class="date-field">
                <mat-label>{{ 'end_date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="endpicker"
                  formControlName="end_date"
                  (focus)="endpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                <mat-datepicker #endpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(treatment.controls.end_date)">{{ 'this_date_is_invalid' | translate }}</mat-error>
              </mat-form-field>
              <gc-location-input
                (placeAutoComplete)="populateAddress($event, i)"
                formControlName="place"
                [forLocation]="'anyLocation'"
                [incommingAddress]="rowListControl.at(i).get('place').value"
              ></gc-location-input>
            </div>
            <button class="delete-button" mat-raised-button color="warn" (click)="deleteTreatment(i)">
              <mat-icon svgIcon="delete"></mat-icon>
              {{ 'delete' | translate }}
            </button>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div class="button-div">
    <button
      mat-flat-button
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      (click)="submit()"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_treatments' | translate }}
    </button>
  </div>
</div>
